import { parse, stringify } from "flatted";
import * as queryString from "query-string";

import { isNullish } from "./primitives";
import { maybe } from "./functional";

export function fromLocalStorage(key, defaultValue) {
  const value = localStorage.getItem(key);
  if (isNullish(value)) {
    return defaultValue;
  }
  return parse(value);
}

export function toLocalStorage(key, value) {
  localStorage.setItem(key, stringify(value));
}

export function clearLocalStorage() {
  localStorage.clear();
}

export function preventDefault(func?) {
  return (event, ...args) => {
    event.preventDefault();
    return maybe(func)(event, ...args);
  };
}

export function stopPropagation(func) {
  return (event, ...args) => {
    event.stopPropagation();
    return maybe(func)(event, ...args);
  };
}

export function eventValue(func) {
  return (event) => maybe(func)(event.target.value);
}

export function persistEvent(func) {
  return (event) => {
    event.persist();
    return maybe(func)(event);
  };
}

export function parseQueryString(args: TODO = {}) {
  const { search, defaults } = args;
  // TODO: We can't use the automated window.location.search because
  // of Gatsby. I wonder if there's a way to do this?
  const result = queryString.parse(search); // || window.location.search)
  if (defaults) {
    for (const [key, value] of Object.entries<TODO>(defaults)) {
      if (!result[key]) {
        result[key] = value;
      }
    }
  }
  return result;
}

export function createScript(args = {}) {
  const { src, content, onLoad } = args;
  const script = document.createElement("script");
  script.type = "text/javascript";
  script.async = true;
  if (src) {
    script.src = src;
  }
  if (content) {
    script.text = content;
  }
  document.head.appendChild(script);
  script.addEventListener("load", onLoad);
}
